<template>
    <div class="text-base text-grey-darkest font-normal min-h-screen flex items-center w-full">
        <div class="flex-1 max-w-sm mx-auto">

            <div class="bg-white rounded shadow">
                <div class="border-b py-8 font-bold text-black text-center text-xl tracking-widest uppercase">
                    Welcome back!
                </div>

                <div class="bg-grey-lightest px-10 py-10">

                    <div class="bg-red-lightest border border-red-light text-red-dark px-4 py-3 rounded relative mb-8" role="alert" v-if="error">
                        <strong class="font-bold">Whoops!</strong>
                        <p class="mt-4">Your credentials are not correct. Please try again.</p>
                    </div>


                    <div class="mb-3">
                        <input class="border w-full p-3 outline-none focus:border-blue-dark" v-bind:class="{'border-red': error}" name="email" type="text" placeholder="E-Mail" v-model="email" required @keyup.enter="loginButtonClicked()">
                    </div>
                    <div class="mb-6">
                        <input class="border w-full p-3 outline-none focus:border-blue-dark" v-bind:class="{'border-red': error}" name="password" type="password" placeholder="**************" v-model="password" required @keyup.enter="loginButtonClicked()">
                    </div>
                    <div class="flex">
                        <button class="bg-blue hover:bg-blue-dark w-full p-4 text-sm text-white uppercase font-bold tracking-wider" v-on:click="loginButtonClicked()">
                            <span v-if="!loggingIn">Log in</span>
                            <span v-if="loggingIn"><i class="fas fa-circle-notch fa-spin"></i> logging in...</span>
                        </button>
                    </div>
                </div>

                <div class="border-t px-10 py-6">
                    <div class="flex justify-between">
                        <router-link to="/auth/register" active-class="text-white" class="font-bold text-blue-dark hover:text-blue-darkest no-underline">
                            Don't have an account?
                        </router-link>
                        <router-link to="/password-reset" active-class="text-white" class="font-bold text-blue-dark hover:text-blue-darkest no-underline">
                            Forgot Password?
                        </router-link>
                    </div>
                </div>  
            </div>

        </div>
    </div>
</template>

<script>

    import * as Config from '@/config'
    import { mapState, mapActions } from 'vuex'

    export default {
        name: 'Login',
        data() {
            return {
                email: '',
                password: '',
                loggingIn: false,
                error: false,
                errors: null,
            }
        },
        mounted() {

        },
        methods: {
            ...mapActions([
                'login'
            ]),
            loginButtonClicked() {
                this.loggingIn = true;

                var self = this;
                this.login({email: this.email, password: this.password})
                    .then((response) => {
                        if(response == 400 || response == 401) {
                            self.error = true;
                            self.loggingIn = false;
                            self.errors = response.data.hint
                            console.log('here')
                        } else {
                            self.loggingIn = false;
                            self.$router.push('/')
                        }
                    })
                    .catch((data) => {
                        self.error = true;
                        self.errors = data.hint;
                        self.loggingIn = false;
                    });
            }
        },
    }

</script>

<style>
    .navbar-logo {
        max-height: 40px;
        width: auto;
    }
    .embed-responsive.embed-responsive-16by9 {
        padding-bottom: 56.25%;
    }
    .embed-responsive {
        position: relative;
        display: block;
        height: 0;
        padding: 0;
        overflow: hidden;
    }
    .embed-responsive .embed-responsive-item, .embed-responsive iframe, .embed-responsive embed, .embed-responsive object {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }
    .topo-bkg {
        background-color: rgba(34,41,47,0.9);
background-image: url("data:image/svg+xml,%3Csvg width='84' height='48' viewBox='0 0 84 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h12v6H0V0zm28 8h12v6H28V8zm14-8h12v6H42V0zm14 0h12v6H56V0zm0 8h12v6H56V8zM42 8h12v6H42V8zm0 16h12v6H42v-6zm14-8h12v6H56v-6zm14 0h12v6H70v-6zm0-16h12v6H70V0zM28 32h12v6H28v-6zM14 16h12v6H14v-6zM0 24h12v6H0v-6zm0 8h12v6H0v-6zm14 0h12v6H14v-6zm14 8h12v6H28v-6zm-14 0h12v6H14v-6zm28 0h12v6H42v-6zm14-8h12v6H56v-6zm0-8h12v6H56v-6zm14 8h12v6H70v-6zm0 8h12v6H70v-6zM14 24h12v6H14v-6zm14-8h12v6H28v-6zM14 8h12v6H14V8zM0 8h12v6H0V8z' fill='%235c5c5c' fill-opacity='0.06' fill-rule='evenodd'/%3E%3C/svg%3E");
    }
</style>
